import { render, staticRenderFns } from "./VerifyAditionalIdentity.vue?vue&type=template&id=2ed0977d&scoped=true&"
import script from "./VerifyAditionalIdentity.vue?vue&type=script&lang=js&"
export * from "./VerifyAditionalIdentity.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAditionalIdentity.vue?vue&type=style&index=0&id=2ed0977d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed0977d",
  null
  
)

export default component.exports